import React, { Component } from 'react';
import { IconButton, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, InputAdornment } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FilterSortBy from '../FilterSortBy/FilterSortBy';
import UplaodForm from '../../../components/forms/UploadForm/UploadForm';
import DocumentViewerModal from '../../Documents/Modals/DocumentViewerModal';
import HandyCard from '../../HandyCard/HandyCard';
import "./Files.css";
import axios from 'axios';
import { APIURL } from '../../../config'
import moment from 'moment'

class Files extends Component {
    state = {
        grid: false,
        artifacts: null,
        artifacts_display: null,
        taskTypeList: [],
        empList: [],
        searchTerm: '',
        filter: { class: '', specifier: '' },
        deleteArt: null,
        deleteModalOpen: false,
        show_upload: false,
        show: false,
        infoID: null,
        docViewerShow: false,
        fileUrl: '',
        fileExt: ''
    }

    handleShow = (id) => { this.setState({ show: true, infoID: id }) };
    handleClose = () => { this.setState({ show: false }) };

    setArtifacts = (artifacts) => {
        this.setState({ ...this.state, artifacts_display: artifacts });
    }

    changeToGrid = () => {
        this.setState({ grid: true })
    }

    changeToRows = () => {
        this.setState({ grid: false })
    }

    renderGrid = () => {
        if (!this.state.artifacts_display) return <div>Loading...</div>;
        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '20px',
                marginTop: '10px',
                marginBottom: '10px',
            }}>
                {this.state.artifacts_display.map((item) => {
                    const file = item.url.split('/')[4]
                    const fileType = file.split('.')[1]
                    return (
                        <HandyCard
                            key={item.id}
                            id={item.id}
                            fileName={item.file_name}
                            fileType={fileType}
                            taskName={item.tas_title}
                            empName={item.empName}
                            url={item.url}
                            artifact={true}
                            date={item.submitted}
                            pname={item.pro_title}
                            del={this.delArt}
                            grid
                            openDocViewer={(url, ext) => this.setState({ docViewerShow: true, fileUrl: url, fileExt: ext })}
                            isAbilityHub={item.isAbilityHub}
                        />
                    )
                })}
            </div>
        );
    }

    renderList = () => {
        if (!this.state.artifacts_display) return <div>Loading...</div>;
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                marginTop: '5px',
                marginBottom: '5px',
            }}>
                {this.state.artifacts_display.map((item) => {
                    const file = item.url.split('/')[4]
                    const fileType = file.split('.')[1]
                    return (
                        <HandyCard
                            key={item.id}
                            id={item.id}
                            fileName={item.file_name}
                            fileType={fileType}
                            taskName={item.tas_title}
                            empName={item.empName}
                            url={item.url}
                            artifact={true}
                            date={item.submitted}
                            pname={item.pro_title}
                            del={this.delArt}
                            openDocViewer={(url, ext) => this.setState({ docViewerShow: true, fileUrl: url, fileExt: ext })}
                            isAbilityHub={item.isAbilityHub}
                        />
                    )
                })}
            </div>
        );
    }

    async fetchData() {
        let artifactsData = await axios.get(APIURL + "/artifacts?cus_id=" + this.props.cus_id)
        let empList = await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: this.props.comp_id } })
        let taskType = await axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: this.props.comp_id } })
        let artifacts = artifactsData.data.map((art) => {
            const employee = empList.data.find(emp => art.employee_id === emp.id)

            if (!employee) {
                return { ...art, empName: " " }
            }

            return { ...art, empName: employee.employee_name }
        })

        if (this.props.user.sec_email?.trim() && this.props.cust_details.cus_email?.trim()) {
            await axios
                .get(APIURL + "/ability_hub/getArtifacts", {
                    params: { userEmail: this.props.user.sec_email, custEmail: this.props.cust_details.cus_email }
                }).then((response) => {
                    console.log('Ability Hub Artifacts fetched', response.data);
                    const ah_Artifacts = response.data.map((art) => ({
                        id: art.ArtifactID,
                        file_name: art.ArtifactName,
                        empName: art.UserName,
                        url: art.ArtifactURL,
                        submitted: art.createdAt,
                        show: art.show,
                        isAbilityHub: true
                    }));

                    artifacts.push(...ah_Artifacts);
                }).catch((error) => {
                    console.log(error);
                });
        }

        this.setState({
            artifacts: artifacts,
            artifacts_display: artifacts.filter((art) => !!art.show).sort((a, b) => new Date(b.submitted) - new Date(a.submitted)),
            empList: empList.data,
            taskTypeList: taskType.data
        })
    }

    async componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.show_upload !== this.state.show_upload) {
            this.fetchData()
        }
    }

    delArtifact = async () => {
        let delArt = await axios.delete(APIURL + '/artifacts', { data: { id: this.state.deleteArt.id } })
        if (delArt.data.code === 200) {
            let artifactsArr1 = this.state.artifacts.filter((art) => art.id !== this.state.deleteArt.id)
            let artifactsArr2 = this.state.artifacts_display.filter((art) => art.id !== this.state.deleteArt.id)

            this.setState({ artifacts_display: artifactsArr2, artifacts: artifactsArr1, deleteArt: null, deleteModalOpen: false })
        } else {
            console.log('Artifact not deleted', delArt.data)
        }
    }

    delArt = (id) => {
        let art = this.state.artifacts_display.find(((art) => art.id === id))
        if (!!art) {
            this.setState({ deleteArt: art, deleteModalOpen: true })
        }
    }

    searchArtHandler = (e) => {
        var searchQuery = e.target.value
        console.log(searchQuery)
        this.setState({ searchTerm: e.target.value })
    }

    searchArtResults = (e) => {
        e.preventDefault()
        var searchTerm = new RegExp(this.state.searchTerm, 'i')
        console.log(searchTerm)
        let artSearchResults = this.state.artifacts.filter((art) => !!art.show).map((art) => {
            if (searchTerm.exec(art.file_name) || searchTerm.exec(art.tas_title) || searchTerm.exec(art.empName)) {
                return art
            }
            else {
                return null
            }
        }).filter((art) => !!art)

        this.setState({ artifacts_display: artSearchResults })
    }
    render() {
        let taskTypeList = this.state.taskTypeList.map((type, index) => <option key={index} value={type}>{type}</option>)
        let content = (
            <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '300px', margin: 5 }}>
                <img src='./projectgraphic.png' alt='ArtTab' style={{ width: '10rem', height: '10rem' }} />
                <h5 style={{ fontFamily: 'Lato', fontSize: 18 }}>No Artifacts found </h5>
                <p style={{ fontFamily: 'Lato', fontSize: 12 }} className='text-muted'>We could not find any artifacts in this projects. Please add files via the Fieldworker mobile app to view them.</p>
            </div>
        )
        if (this.state.grid && this.state.artifacts_display) {
            if (this.state.artifacts_display.length > 0) {
                content = (
                    <div style={{ height: '700px', overflow: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 8 }}>
                            <div className="Artifacts">
                                <ul style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li onClick={() => this.changeToGrid()} style={{ cursor: 'pointer', marginRight: 8 }}><i className="fas fa-th"></i></li>
                                    <li onClick={() => this.changeToRows()} style={{ cursor: 'pointer' }}><i className="fas fa-list"></i></li>
                                </ul>
                            </div>
                        </div>
                        {this.renderGrid()}
                    </div>
                )
            } else {
                content = (
                    <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '300px', margin: 5 }}>
                        <img src='./projectgraphic.png' alt='ArtTab' style={{ width: '10rem', height: '10rem' }} />
                        <h5 style={{ fontFamily: 'Lato', fontSize: 18 }}>No Artifacts found </h5>
                        <p style={{ fontFamily: 'Lato', fontSize: 12 }} className='text-muted'>We could not find any artifacts in this projects. Please add files via the Fieldworker mobile app to view them.</p>
                    </div>
                )
            }
        } else if (!this.state.grid && this.state.artifacts_display) {
            if (this.state.artifacts_display.length > 0) {
                content = (
                    <div className='overflow-auto' style={{ height: '100%' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 8 }}>
                            <div className="Artifacts">
                                <ul style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li onClick={() => this.changeToGrid()} style={{ cursor: 'pointer', marginRight: 8 }}><i className="fas fa-th"></i></li>
                                    <li onClick={() => this.changeToRows()} style={{ cursor: 'pointer' }}><i className="fas fa-list"></i></li>
                                </ul>
                            </div>
                        </div>
                        {this.renderList()}
                    </div>
                )
            } else {
                content = (
                    <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '300px', margin: 5 }}>
                        <img src='./projectgraphic.png' alt='ArtTab' style={{ width: '10rem', height: '10rem' }} />
                        <h5 style={{ fontFamily: 'Lato', fontSize: 18, marginTop: 48, marginBottom: 28 }}>No Artifacts found </h5>
                        <p style={{ fontFamily: 'Lato', fontSize: 14 }} className='text-muted text-center w-50'>We could not find any artifacts in this projects. Please add files via the Fieldworker mobile app to view them.</p>
                    </div>
                )
            }
        } else {
            content = <div className='d-flex flex-row w-100 justify-content-center mt-5'><div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div></div>
        }
        return (
            <div className="TasksPage">
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="TopPanel">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                onChange={(e) => this.searchArtHandler(e)}
                                value={this.state.searchTerm}
                                placeholder="Search"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton type="submit">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <Button variant="contained" color="primary" onClick={() => this.setState({ ...this.state, show_upload: true })}>
                            Upload
                        </Button>
                    </div>
                    <FilterSortBy artifacts={this.state.artifacts} artifactsDisplay={this.state.artifacts_display} setArtifacts={this.setArtifacts} taskList={'taskList'} taskTypeList={taskTypeList} empList={'empList'} />
                </div>
                <div className='tasks_info'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <h5>Files</h5>
                        </div>
                    </div>
                    {content}
                </div>
                <Dialog open={this.state.show_upload} onClose={() => { this.setState({ ...this.state, show_upload: false }) }}>
                    <DialogActions>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.25 }}
                            onClick={() => { this.setState({ ...this.state, show_upload: false }) }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                    <DialogContent sx={{ paddingTop: '0px', width: 370 }}>
                        <UplaodForm company_id={this.props.comp_id} mode='add' user={this.props.user} customer_id={this.props.cus_id} onSubmit={() => { this.setState({ ...this.state, show_upload: false }) }}></UplaodForm>
                    </DialogContent>
                </Dialog>
                <DocumentViewerModal
                    open={this.state.docViewerShow}
                    handleClose={() => this.setState({ docViewerShow: false })}
                    fileUrl={this.state.fileUrl}
                    fileExt={this.state.fileExt}
                />
                <Dialog open={this.state.deleteModalOpen} onClose={() => this.setState({ deleteModalOpen: false })} fullWidth maxWidth="sm">
                    <DialogTitle>Delete Artifact {!this.state.deleteArt ? '' : this.state.deleteArt.file_name}</DialogTitle>
                    <DialogContent>
                        <hr className="HorizontalLine" />
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
                        <Button variant="outlined" onClick={() => this.setState({ deleteModalOpen: false })}>Cancel</Button>
                        <Button variant="contained" onClick={() => this.delArtifact()}>Delete</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default Files;